import template from './chargecode-table.html';
import controller from './chargecode-table.controller';

let ChargecodeTableComponent = {
  restrict: 'E',
  bindings: {
    chargecodes: '=',
    onDelete: '&?' // only show delete option if callback is set
  },
  template,
  controller
};

export default ChargecodeTableComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/employee-create/components/chargecode-table/chargecode-table.component.js